import { BuyCloudOrgSetupPageTemplate } from "../../../../templates/buy/cloud/org-setup/src";

export const BuyCloudOrgSetupPage = () => <BuyCloudOrgSetupPageTemplate />;
